import { Component, OnDestroy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OrderNavbarComponent } from './_common/order-navbar/order-navbar.component';
import { FpFooterComponent } from '../front-pages/common/fp-footer/fp-footer.component';

@Component({
    selector: 'order-page',
    imports: [RouterOutlet, OrderNavbarComponent, FpFooterComponent],
    templateUrl: './order-page.component.html',
    styleUrl: './order-page.component.scss'
})
export class OrderPageComponent implements OnDestroy {

    constructor(){

    }

    ngOnDestroy(): void {

    }
}